import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import i18n from './i18n';

if (import.meta.env.PROD && typeof window !== 'undefined') {
  const noop = () => undefined;
  window.console.log = noop;
  window.console.info = noop;
  window.console.warn = noop;
  window.console.error = noop;
  window.console.debug = noop;
}

// Set robots meta tag based on environment
const environment = import.meta.env.VITE_ENVIRONMENT || 'local';
if (environment !== 'prod') {
  const metaRobots = document.createElement('meta');
  metaRobots.name = 'robots';
  metaRobots.content = 'noindex, nofollow';
  document.head.appendChild(metaRobots);
}

document.documentElement.lang = i18n.language === 'en' ? 'en' : 'sv';
i18n.on('languageChanged', (language) => {
  document.documentElement.lang = language === 'en' ? 'en' : 'sv';
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minuter
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

// Register service worker only in production to avoid issues during dev (Vite)
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(() => undefined)
      .catch(() => undefined);
  });
}
